import { useParams } from "react-router-dom";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const tableData = [
  { month: "April", estimated_amount: "2000", actual_amount: "1800" },
  { month: "May", estimated_amount: "2000", actual_amount: "1900" },
  { month: "June", estimated_amount: "2000", actual_amount: "2000" },
  { month: "July", estimated_amount: "2000", actual_amount: "2100" },
  { month: "August", estimated_amount: "2000", actual_amount: "2200" },
  { month: "September", estimated_amount: "2000", actual_amount: "2300" },
];

const EmployeeTdsLedger = () => {
  const { id, username } = useParams();

  const breadcrumbs = [
    { label: "Employees", link: "/employee-details" },
    { label: "Employee Details", link: `/employee-details/${id}/${username}` },
    { label: "TDS Ledger", link: "" },
  ];

  return (
    <>
      <div className=" px-4 py-4 flex justify-between sticky bg-white top-16 shadow-lg z-40">
        <div className="flex items-center space-x-4">
          <h2 className="text-2xl font-semibold">TDS Ledger for {username}</h2>
        </div>
      </div>

      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>

      <div className="px-4 my-5">
        <p className="mb-5 text-base">
          Total TDS for the year:{" "}
          <span className="font-semibold text-primary">&#8377; 13,600</span>
        </p>

        <RoundedContainer>
          <div className="max-w-full overflow-x-auto">
            <Table className="w-full table-auto">
              <TableHead>
                <TableHeaderCell className="w-1/3 text-center">
                  Month
                </TableHeaderCell>
                <TableHeaderCell className="w-1/3 text-center">
                  Estimated Amount
                </TableHeaderCell>
                <TableHeaderCell className="w-1/3 text-center">
                  Actual Amount
                </TableHeaderCell>
              </TableHead>
              <TableBody>
                {tableData.map((row, index) => {
                  const { month, estimated_amount, actual_amount } = row;
                  return (
                    <TableRow key={index}>
                      <TableCell className="text-center text-dark font-medium text-sm">
                        {month}
                      </TableCell>
                      <TableCell className="text-center text-dark font-medium text-sm">
                        &#8377; {estimated_amount}
                      </TableCell>
                      <TableCell className="text-center text-dark font-medium text-sm">
                        &#8377; {actual_amount}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </RoundedContainer>
      </div>
    </>
  );
};

export default EmployeeTdsLedger;
